import { render, staticRenderFns } from "./RfvPdf.vue?vue&type=template&id=322bd842&scoped=true"
import script from "./RfvPdf.vue?vue&type=script&lang=js"
export * from "./RfvPdf.vue?vue&type=script&lang=js"
import style0 from "./RfvPdf.vue?vue&type=style&index=0&id=322bd842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322bd842",
  null
  
)

export default component.exports